/**
 * Created by Jie Gao on 2018-11-07.
 */
import {BetLinesView, IBetLinesViewConfig} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {BetLineNumber} from "@nolimitcity/slot-game/bin/core/betline/BetLineNumber";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {StarStruckBetline} from "./StarStruckBetline";

export class StarStruckBetlinesView extends BetLinesView {
    private readonly _ssNumberFactoryMethod:(index:number) => BetLineNumber;
    private readonly _ssLineFactoryMethod:(index:number, numberPosition:number[], betLineData:number[]) => StarStruckBetline;
    private readonly _ssBetlineConfig:IBetLinesViewConfig;
    private _ssBetLinesData:number[][];

    constructor(config:IBetLinesViewConfig,
                numberFactoryMethod:(index:number) => BetLineNumber,
                lineFactoryMethod:(index:number, numberPosition:number[], betLineData:number[]) => StarStruckBetline) {

        super(config, numberFactoryMethod, lineFactoryMethod);
        this._ssNumberFactoryMethod = numberFactoryMethod;
        this._ssLineFactoryMethod = lineFactoryMethod;
        this._ssBetlineConfig = config;
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.parsedInitData(event.params[0]));
    }

    private parsedInitData(data:ParsedInitData):void {
        this._ssBetLinesData = data.betLines.concat(data.betLines);
        if(this._ssBetLinesData.length != this._ssBetlineConfig.map.length) {
            debugger;
            throw new Error(`Error: There are only ${this._ssBetlineConfig.map.length} betLines in the config order while the server sends ${this._ssBetLinesData.length} lines.`);
        }

        this._dataInitialized = true;
        this.draw();
    }

    protected draw():void {
        if(!this._resourcesLoaded || !this._dataInitialized) {
            return;
        }

        const map:number[] = this._ssBetlineConfig.map;
        const numNumbers:number = map.length;
        for(let i:number = 0; i < numNumbers; i++) {
            const betLineNumber:BetLineNumber = this._ssNumberFactoryMethod(map[i]);
            const betLineNumberPosition:number[] = betLineNumber.setPosition(this._ssBetLinesData.length, i);
            this._betLineNumbers.push(betLineNumber);

            if(i < numNumbers/2) {
                const betLine:StarStruckBetline = this._ssLineFactoryMethod(map[i], betLineNumberPosition, this._ssBetLinesData[map[i]]);
                this._betLines.push(betLine);
            }
        }

        (<StarStruckBetline[]>this._betLines).sort((a:StarStruckBetline, b:StarStruckBetline) => {
            return a.index - b.index;
        });

        this._betLineNumbers.sort((a:BetLineNumber, b:BetLineNumber) => {
            return a.index - b.index;
        });
    }
}